import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import { tableContainerStyles, tableFooterStyles } from './DataTable.styles';
import _ from 'lodash';
import { TABLES } from '@/Constants';
import { useTranslation } from 'react-i18next';
import { PaginationActions } from '@/Components/Common';
import { useEffect } from 'react';
import { RootState, useTypedDispatch } from '@/store';
import { InboxActions } from '@/Actions';
import {
  IPaginationFilter,
  IPaginationMeta,
} from '@/Interfaces/PaginationMeta.interface';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
const { fetchInbox } = InboxActions;

const { INBOX_TABLE_HEADER } = TABLES;

interface IInbox {
  onRowAction(data: any, action: 'detail'): void;
}
// const InboxTable: React.FC<IInbox> = ({ onRowAction }) => {
const InboxTable: React.FC<IInbox> = ({ }) => {
  const dispatch = useTypedDispatch();
  const { t } = useTranslation('translation');
  const colSpan = INBOX_TABLE_HEADER.length + 5;
  const meta: IPaginationMeta = useSelector((state: RootState) =>
    _.get(state.INBOX, 'meta')
  );
  const pagination: IPaginationFilter = useSelector((state: RootState) =>
    _.get(state.INBOX, 'pagination')
  );
  const inboxs = useSelector((state: RootState) =>
    _.get(state.INBOX, 'inboxs')
  );
  const isFetchLoading = useSelector((state: RootState) =>
    _.get(state.INBOX, 'isGetLoading')
  );

  useEffect(() => {
    dispatch(fetchInbox({ page: 1, limit: 10 }));
  }, []);

  const handleChangePage = (
    _event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
    type?: string
  ) => {
    let page = pagination.page;
    if (type === 'lastPage') page = newPage;
    else {
      if (newPage === 0) page = 1;
      else if (newPage < page) page -= 1;
      else if (newPage >= page) page += 1;
    }
    dispatch(fetchInbox({ ...pagination, page }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const perPage = parseInt(event.target.value, 10);
    dispatch(fetchInbox({ ...pagination, limit: perPage }));
  };

  const _renderTableHeader = () => {
    return (
      <TableRow>
        <TableCell sx={{ maxWidth: 50 }}>{t('table.no')}</TableCell>
        {_.map(INBOX_TABLE_HEADER, (item) => (
          <TableCell
            key={`head-${item.value}`}
            sx={{ fontWeight: '700', minWidth: 250 }}
          >
            {t(`table.${item?.value}`)}
          </TableCell>
        ))}
        <TableCell sx={{ maxWidth: 100, textAlign: 'center' }}>
          {t('table.date')}
        </TableCell>
      </TableRow>
    );
  };

  const _renderTableBody = () => {
    if (_.isEmpty(inboxs))
      return (
        <TableRow>
          <TableCell colSpan={colSpan + 1}>
            There is no Inbox to display
          </TableCell>
        </TableRow>
      );
    return _.map(inboxs, (item: any, index: number) => {
      const unsubscribeDate = dayjs(item.createdAt).format('DD/MM/YYYY');
      return (
        <TableRow hover key={index}>
          <TableCell>
            {index + 1 + (meta?.currentPage - 1) * pagination?.limit}
          </TableCell>
          <TableCell>{item.email}</TableCell>
          <TableCell>
            <Typography
              sx={{
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                textOverflow: 'ellipsis',
              }}
            >
              {item.content}
            </Typography>
          </TableCell>
          <TableCell>{t(`label.${item.country}`)}</TableCell>
          
          <TableCell>{unsubscribeDate}</TableCell>
          
        </TableRow>
      );
    });
  };

  const _renderFooter = () => {
    return (
      <TableFooter sx={tableFooterStyles}>
        <TableRow>
          <TablePagination
            rowsPerPageOptions={[10]}
            colSpan={colSpan + 5}
            count={meta?.totalItems || 0}
            rowsPerPage={meta?.itemsPerPage || 0}
            page={meta?.currentPage - 1 || 0}
            SelectProps={{
              inputProps: {
                'aria-label': 'rows per page',
              },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={PaginationActions}
          />
        </TableRow>
      </TableFooter>
    );
  };

  const _renderTable = () => {
    return (
      <TableContainer component={Paper} sx={tableContainerStyles}>
        <Table stickyHeader>
          <TableHead>{_renderTableHeader()}</TableHead>
          <TableBody>
            {!isFetchLoading ? (
              _renderTableBody()
            ) : (
              <TableRow>
                <TableCell colSpan={colSpan + 1} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
          {_renderFooter()}
        </Table>
      </TableContainer>
    );
  };

  return <Box>{_renderTable()}</Box>;
};

export default InboxTable;
